<template>
	<div class="tw-w-full tw-flex-1">
		<router-view v-if="$route.meta.skipCache" :key="route"></router-view>
		<keep-alive v-else>
			<router-view :key="route"></router-view>
		</keep-alive>
	</div>
</template>

<script>
    export default {
        name: 'MainViewHolder',

        computed: {
            // remove tab param from route otherwise each tab will be cached separately which will result in multiple instances of the sidebar
            route() {
                let route = this.$route.path;

                if (typeof this.$route.params.tab !== 'undefined') {
                    const tab_name = this.$route.params.tab;

                    route = route.replace(`/${tab_name}`, '');
                }

                return route;
            },
        },
    };
</script>

